import { Instagram, Linkedin } from "lucide-react";
import { useLang } from "../i18n";
import { scrollToId } from "../smooth";

const Footer = () => {
    const { t, lang } = useLang();
    const cols = [
        { title: t.footer.col1, links: t.footer.col1Links, target: "#collection", testid: "footer-col-collection" },
        { title: t.footer.col2, links: t.footer.col2Links, target: "#story", testid: "footer-col-about" },
        { title: t.footer.col3, links: t.footer.col3Links, target: "#hospitality", testid: "footer-col-hospitality" },
    ];
    return (
        <footer id="contact" data-testid="site-footer" className="bg-navy-deep text-ivory">
            <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-2 md:px-10 md:py-20 lg:grid-cols-5">
                <div className="lg:col-span-2">
                    <div className="flex items-center gap-4">
                        <img src="/assets/emblem.png" alt="LARIVA emblem" className="h-14 w-auto" loading="lazy" />
                        <span className="leading-none">
                            <span className="block font-serif text-3xl tracking-[0.26em] text-ivory">LARIVA</span>
                            <span className="mt-1.5 block text-[8px] tracking-[0.4em] text-champagne">
                                ITALIAN LAKES COLLECTION
                            </span>
                        </span>
                    </div>
                    <p className="mt-6 text-sm leading-relaxed text-ivory/60">
                        {t.footer.tag1}
                        <br />
                        {t.footer.tag2}
                        <br />
                        {t.footer.tag3}
                    </p>
                </div>

                {cols.map((col) => (
                    <div key={col.title} data-testid={col.testid}>
                        <h4 className="text-[11px] tracking-[0.32em] text-champagne uppercase">{col.title}</h4>
                        <ul className="mt-5 space-y-3">
                            {col.links.map((l, i) => {
                                const target =
                                    col.testid === "footer-col-hospitality" && i === 2 ? "#request" : col.target;
                                return (
                                    <li key={l}>
                                        <a
                                            href={target}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                scrollToId(target);
                                            }}
                                            className="text-sm text-ivory/65 transition-colors duration-500 hover:text-champagne"
                                        >
                                            {l}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}

                <div data-testid="footer-col-contact">
                    <h4 className="text-[11px] tracking-[0.32em] text-champagne uppercase">{t.footer.col4}</h4>
                    <ul className="mt-5 space-y-3 text-sm">
                        <li>
                            <a
                                href="mailto:hello@larivacomo.com"
                                data-testid="footer-email-hello"
                                className="text-ivory/65 transition-colors duration-500 hover:text-champagne"
                            >
                                hello@larivacomo.com
                            </a>
                        </li>
                        <li>
                            <a
                                href="mailto:hospitality@larivacomo.com"
                                data-testid="footer-email-hospitality"
                                className="text-ivory/65 transition-colors duration-500 hover:text-champagne"
                            >
                                hospitality@larivacomo.com
                            </a>
                        </li>
                    </ul>
                    <div className="mt-6 flex gap-4">
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            data-testid="social-instagram"
                            className="flex h-9 w-9 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-500 hover:bg-champagne hover:text-navy-deep"
                        >
                            <Instagram size={15} strokeWidth={1.5} />
                        </a>
                        <a
                            href="https://linkedin.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                            data-testid="social-linkedin"
                            className="flex h-9 w-9 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-500 hover:bg-champagne hover:text-navy-deep"
                        >
                            <Linkedin size={15} strokeWidth={1.5} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="border-t border-ivory/10">
                <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 text-[11px] tracking-[0.14em] text-ivory/45 md:flex-row md:px-10">
                    <span data-testid="footer-rights">{t.footer.rights}</span>
                    <span className="flex gap-8">
                        <a
                            href={lang === "it" ? "/it/privacy" : "/privacy"}
                            data-testid="footer-privacy"
                            className="transition-colors duration-500 hover:text-champagne"
                        >
                            {t.footer.privacy}
                        </a>
                        <a
                            href={lang === "it" ? "/it/terms" : "/terms"}
                            data-testid="footer-terms"
                            className="transition-colors duration-500 hover:text-champagne"
                        >
                            {t.footer.terms}
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
